module.exports = __webpack_public_path__ + "static/media/6.fe95aa31.jpeg";